<template>
  <div class="KeynoteSpeech subWrapper">
    <!-- logo + menu -->
    <LogoMenu :loadmounted="isPc" :active-name="menuName" />
    <!-- 主题演讲 -->
    <div class="sub_contBox" v-if="!isPc">
      <div class="contbox_scroll">
        <!-- 内容 -->
        <div class="contbox_top">
          <!-- 主题演讲 txt -->
          <div class="sub_title"><img src="../assets/image/right_arrow.png" /><span>{{ name }}</span><img src="../assets/image/left_arrow.png" /></div>
          <!-- 图片 -->
          <img src="../assets/image/live_img.png" class="live-img" />
          <!-- 文字 -->
          <p class="live-txt">2021中国（上海）国际隧道工程研讨会圆满闭幕。这是一场超高规格、超高水准的学术盛会；这是一场立意高远、内容丰盛的思想盛宴。为期2天的会议，共设置1个主旨论坛，6个主题论坛，来自中国、日本、意大利、奥地利、巴西等多个国家行业人士通过线上线下的模式共襄盛举，通过近100个学术报告共同探讨“城市复杂环境下隧道工程的挑战与创新”，为城市地下空间建设发展汇聚创新力量与智慧方案。</p>
          <!-- 论坛主题 -->
          <ul class="speech-box">
            <li v-for="(item, index) in speechArr" :key="index" :class="speechNowId == item.id ? 'speech-active' : ''" @click="ChangeThemeFn(item.id)">{{ item.name }}</li>
          </ul>
          <!-- 内容 -->
          <ul class="speech-video-box">
            <li v-for="(item, index) in speechList" :key="index">
              <a :href="item.url" target="_blank">
                <div class="video-img">
                  <img :src="item.imagePath" />
                  <span></span>
                </div>
                <p class="Linebreak">{{ item.name }}</p>
              </a>
            </li>
          </ul>
        </div>
        <!-- 底部信息 -->
        <Foot />
      </div>
    </div>
    <!-- pc -->
    <div class="sub_contBox" v-else>
      <!-- 面包屑 -->
      <div class="Breadcrumb_box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ activeName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 主体 -->
      <div class="content_box">
        <!-- 侧边栏 -->
        <ul class="sidebar">
          <li v-for="(item,index) in speechArr" :key="index" :class="speechNowId == item.id ? 'on' : ''" @click="ChangeThemePcFn(item.id,item.name)">{{ item.name }}</li>
        </ul>
        <!-- 内容 -->
        <div class="content_txt">
          <ul class="speech-video-wrap">
            <li v-for="(item,index) in speechList" :key="index">
              <a :href="item.url">
                <div class="video-img-box">
                  <img :src="item.imagePath" />
                </div>
                <div class="video-info-box">
                  <h2>{{ item.name }}</h2>
                  <p class="Linebreak">{{ item.introduction }}</p>
                </div>
              </a>
            </li>
          </ul>
          <!-- 分页器 -->
          <div class="page">
            <Pagination :total='pageTotal' :page="page" :pageSize='pagesize' @currentPage="CurrentPage"></Pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部信息 -->
    <Foot v-if="isPc" />
  </div>
</template>

<script>
  import LogoMenu from '../components/LogoMenu.vue'
  import { AccessRecordsApi,KeynoteSpeechAllApi,KeynoteSpeechApi } from '../request/api.js'
  import Foot from '../components/Footer.vue'
  import Pagination from '../components/Pagination.vue'
  export default {
    name: "KeynoteSpeech",
    data() {
      return {
        name: '主题演讲',
        isPc: false, // false:pc true:mobile
        menuName: '',
        speechArr: [{ name: '主论坛', id: 116 },{ name: '主题论坛一', id: 117 },{ name: '主题论坛二', id: 118 },{ name: '主题论坛三', id: 119 },{ name: '主题论坛四', id: 120 },{ name: '主题论坛五', id: 121 },{ name: '主题论坛六', id: 122 }],
        speechNowId: 116,
        speechDataAll: [],  // 全部主题的图
        speechList: [],  // 当前主题的图
        activeName: '主论坛',
        pageTotal: 0,
        page: 1,
        pagesize: 5,
      }
    },
    created() {
      let wid = window.innerWidth;
      this.menuName = this.$route.query.name;
      this.speechNowId = this.$route.query.videoSubclassId ? this.$route.query.videoSubclassId : this.speechNowId;
      if (wid >= 320 && wid <= 1024) {
        this.isPc = false;
        this.GetSpeechApiFn();
      } else {
        this.isPc = true;
        this.GetSpeechPcApiFn();
        // 获取当前论坛id对应的论坛名
        for(let i=0;i<this.speechArr.length;i++){
          if(this.speechNowId == this.speechArr[i].id){
            this.activeName = this.speechArr[i].name;
            return;
          }
        }
      }
    },
    mounted() {
      this.AccessRecordsFn();
    },
    methods: {
      // 获取数据-mobile
      GetSpeechApiFn() {
        KeynoteSpeechAllApi({
          ChildrenSorting: 'displayIndex asc,creationDate asc'
        }).then(res => {
          this.speechDataAll = res;
          for(let i=0;i<res.length;i++){
            if(this.speechNowId == res[i].videoSubclassId){
              this.speechList = res[i].videos;
              return;
            }
          }
        });
      },
      // 切换论坛-mobile
      ChangeThemeFn(id){
        let flag = false;
        this.speechNowId = id;
        for(let i=0;i<this.speechDataAll.length;i++){
          if(id == this.speechDataAll[i].videoSubclassId){
            this.speechList = this.speechDataAll[i].videos;
            flag = true;
            return;
          }

          if(i == this.speechDataAll.length - 1 && !flag){
            this.speechList = [];
          }
        }
      },
      // 获取分页视频-pc
      GetSpeechPcApiFn(){
        KeynoteSpeechApi({
          VideoSubclassId: this.speechNowId,
          PageSize: this.pagesize,
          PageNumber: this.page,
          Sorting: 'displayIndex desc,creationDate desc'
        }).then(res => {
         this.speechList = res.items;
         this.pageTotal = res.totalCount;
        });
      },
      // 切换论坛-pc
      ChangeThemePcFn(id,name){
        this.activeName = name;
        this.speechNowId = id;
        this.page = 1;
        this.GetSpeechPcApiFn();
      },
      // 分页器
      CurrentPage(index) {
        this.page = index;
        this.GetSpeechPcApiFn();
      },
      // 访问记录
      AccessRecordsFn() {
        AccessRecordsApi({
          seminarTopicId: 13
        });
      }
    },
    components: {
      LogoMenu,
      Foot,
      Pagination
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .live-img{
      width: 100%;
      height: auto;
    }

    .live-txt{
      line-height: 30px;
      text-align: left;
      text-indent: 2em;
      margin-bottom: 30px;
      margin-top: 20px;
      font-size: 17px;
    }

    .live-line{
      height: 1px;
      background-color: #eaeaea;
    }

    .speech-box{
      display: flex;
      border: 1px solid #1058bb;
      margin: 30px 0 15px;
    }

    .speech-box li{
      width: 100%;
      cursor: pointer;
      border-left: 1px solid #1058bb;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
    }

    .speech-box li:first-child{
      border-left: 0;
    }

    .speech-active{
      background-color: #1058bb;
      color: #FFFFFF;
    }

    .speech-pic{
      display: flex;
      flex-wrap: wrap;
    }

    .speech-pic li{
      width: 19.2%;
      margin: 15px 1% 0 0;
    }

    .speech-pic li:nth-child(5n){
      margin-right: 0;
    }

    .speech-pic li img{
      width: 100%;
      height: 145px;
      cursor: pointer;
    }

    /* 视频 */
    .speech-video-wrap{
      border-top: 1px solid #eaeaea;
      margin-top: 50px;
    }

    .speech-video-wrap a{
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      border-bottom: 1px dashed #999;
      padding: 20px 0;
    }

    .video-img-box img{
      width: 180px;
      height: 120px;
    }

    .video-info-box{
      width: 770px;
    }

    .video-info-box h2{
      font-size: 18px;
      margin-bottom: 10px;
    }

    .video-info-box p{
      font-size: 14px;
      line-height: 24px;
      max-height: 48px;
    }

    .page{
      margin: 60px 0;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1024px) {
    .KeynoteSpeech{
      position: relative;
      /* padding: 1.2rem 0 0; */
      overflow: hidden;
    }

    .Live-menu .sub_contBox{
      padding: 1rem 0 0;
    }

    .live-img{
      width: 100%;
      height: auto;
    }

    .live-txt{
      font-size: .28rem;
      line-height: .48rem;
      text-indent: .56rem;
    }

    .speech-box{
      display: flex;
      flex-wrap: wrap;
      border: solid 1px #1058bb;
      margin: .2rem 0 .25rem;
    }

    .speech-box li{
      font-size: .28rem;
      line-height: .48rem;
      text-align: center;
      width: 33.3%;
    }

    .speech-box li:first-child{
      width: 100%;
      border-bottom: solid 1px #1058bb;
    }

    .speech-box li:nth-child(3), .speech-box li:nth-child(6){
      border-left: solid 1px #1058bb;
      border-right: solid 1px #1058bb;
    }

    .speech-box li:nth-child(2), .speech-box li:nth-child(3), .speech-box li:nth-child(4){
      border-bottom: solid 1px #1058bb;
    }

    .speech-active{
      background-color: #1058bb;
      color: #FFFFFF;
    }

    .speech-video-box{
      display: flex;
      flex-wrap: wrap;
      min-height: 1.5rem;
    }

    .speech-video-box li{
      width: 33%;
      margin-right: .5%;
      margin-bottom: 10px;
    }

    .speech-video-box li:nth-child(3n){
      margin-right: 0;
    }

    .speech-video-box a{
      display: block;
    }

    .video-img{
      position: relative;
    }

    .video-img span{
      display: block;
      width: .56rem;
      height: .56rem;
      background: url(../assets/image/play_icon.png) no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }

    .speech-video-box a img{
      width: 100%;
      height: auto;
    }

    .speech-video-box a p{
      line-height: .4rem;
      max-height: .88rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/KeynoteSpeech.vue